module.exports = __webpack_public_path__ + "img/syltech.95029d0d.png";